import { render, staticRenderFns } from "./MemberInfo.pug?vue&type=template&id=4c6817a6&scoped=true&lang=pug&"
import script from "./MemberInfo.vue?vue&type=script&lang=js&"
export * from "./MemberInfo.vue?vue&type=script&lang=js&"
import style0 from "./MemberInfo.scss?vue&type=style&index=0&id=4c6817a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6817a6",
  null
  
)

export default component.exports